import {api} from "@/utils/macros/apiRoutes"

const getAnalyticsData = async function (request) {
    if (!request?.dateRanges) {
        Object.assign(request, {
            dateRanges: [
                {
                    startDate: '2020-03-31',
                    endDate: 'today',
                },
            ]
        })
    }

    const response = await this.$functions.fetch(api.getAnalyticsData, {
        data: request
    })
    const {data} = response
    return data
}

export default {
    getAnalyticsData
}
